document.addEventListener('DOMContentLoaded', function () {
      const faqSections = document.querySelectorAll('.oswaal-faq');

faqSections.forEach(function (section) {
  if (section.dataset.oswaalFaqBound === 'true') return;

  const questions = section.querySelectorAll('.oswaal-faq__question');

  section.dataset.oswaalFaqBound = 'true';

        questions.forEach(function (button) {
          button.addEventListener('click', function () {

            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const answerId = button.getAttribute('aria-controls');
            const answer = document.getElementById(answerId);
            const icon = button.querySelector('.oswaal-faq__icon');

            // Close all other FAQ items
            questions.forEach(function (otherButton) {
              if (
              otherButton !== button &&
              otherButton.getAttribute('aria-expanded') === 'true'
            ) {
                const otherAnswerId = otherButton.getAttribute('aria-controls');
                const otherAnswer = document.getElementById(otherAnswerId);
                const otherIcon = otherButton.querySelector('.oswaal-faq__icon');

                otherButton.setAttribute('aria-expanded', 'false');

                if (otherAnswer) {
                  otherAnswer.hidden = true;
                }

                if (otherIcon) {
                  otherIcon.textContent = '+';
                }
              }
            });

            // Toggle current FAQ
            button.setAttribute(
              'aria-expanded',
              String(!isExpanded)
            );

            if (answer) {
              answer.hidden = isExpanded;
            }

            if (icon) {
              icon.textContent = isExpanded ? '+' : '−';
            }
          });
        });
      });
    });